import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const user = {
  state: {
    userInfo: {},
    menus: []
  },
  actions,
  getters,
  mutations
}

export default user



// WEBPACK FOOTER //
// ./src/store/module/user/index.js